import { Component, Input } from '@angular/core';

type PaddingStyle = 'all' | 'laptopUp';

@Component({
  selector: 'fin-booking-widget-selector',
  templateUrl: 'booking-widget-selector.component.html',
  styleUrls: ['./booking-widget-selector.component.scss'],
})
export class BookingWidgetSelectorComponent {
  readonly paddingStyle: Record<PaddingStyle, string> = {
    all: 'pad-all',
    laptopUp: 'pad-laptop-up',
  };

  @Input()
  disabled = false;

  @Input()
  label: string;

  @Input()
  ariaLabel?: string;

  @Input()
  separatorPadding?: PaddingStyle;
}
